import { useSelector, useDispatch } from 'react-redux';
import {
  Card
} from 'cdk-radial';
import { updateBundleCMFSelectionInCart } from '../../../../../redux/connectedComponent/orderAPI/orderAPI.slice';
import { useState, useEffect } from 'react';
import OrderAPIStepperFooter from '../StepperFooter/OrderAPIStepperFooter';
import './ConfigureCMFNumber.scss';
import { ORDER_APIS_STEPPER_FOOTER } from '../../../../../constants/APIDirectoryConstants';
import { Constants, RESOURCE_TYPES } from '../../../../../constants/constants';
import { ConfigureCMFDropdown } from './ConfigureCMFDropdown';

export default function ConfigureCMFNumber({ setActiveStep, activeStep, cart }) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);

  const [locationOptions, setLocationsOptions] = useState([]);
  const [isAllBundlesCMFConfigured, setIsAllBundlesCMFConfigured] = useState(false);

  useEffect(() => {
  const locationsWithCMF = state?.loginDetailsSlice?.canPurchaseEnabled || [];
    const options = locationsWithCMF.map((location) => ({
      label: `CMF ${location.cmfNumber} - ${location.partyName}`,
      value: `${location.storeId}-${location.cmfNumber}`
    }));
    setLocationsOptions(options);

  }, [state?.loginDetailsSlice?.canPurchaseEnabled]);

  const isPricedBundle = (item) => {
    if (item.resourceType?.toLowerCase() === RESOURCE_TYPES.BUNDLE && item.resourcePricingPlanId) {
      // Check if the pricing plan has installFee attribute
      const pricingPlan = item.details?.plans?.find(
        plan => plan.id === item.resourcePricingPlanId
      );
      return pricingPlan?.installFee != null ? true : false;
    }
    return false;
  }

  useEffect(() => {
    const pricedBundles = cart.filter(isPricedBundle);
    setIsAllBundlesCMFConfigured(
      pricedBundles.length === 0 || pricedBundles.every(item => !!item.selectedCMFNumber)
    );
  }, [cart]);

  const handleSelect = (bundleId, option) => {
    dispatch(
      updateBundleCMFSelectionInCart({
        bundleId,
        selectedCMFNumber: option?.value?.split('-')[1],
        selectedStoreId: option?.value?.split('-')[0]
      })
    );
  }

  return (
    <>
      <Card className="configure-cmf-container-card">
        <div className="configure-cmf-container">
          <span className="configure-cmf-title">
            {Constants.CONFIGURE_CMF_NUMBER}
          </span>
          <div className="configure-cmf-div">
          <div className="configure-cmf-description">
            {Constants.CONFIGURE_CMF_DESCRIPTION}
          </div>
          {cart
            .filter(isPricedBundle)
            .map((item) => (
              <div className='configure-cmf-number' key={item.resourceId}>
                <div className='configure-cmf-row'>
                  <span className="configure-cmf-number-card-title">{item?.details?.name}</span>
                  <span className="configure-cmf-number-card-description">
                    <ConfigureCMFDropdown
                      instanceId={item.resourceId}
                      selectedValue={`${item.selectedStoreId}-${item.selectedCMFNumber}`}
                      locationOptions={locationOptions}
                      onSelect={(option) => handleSelect(item.resourceId, option)}
                    />
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Card>
      <OrderAPIStepperFooter
        setActiveStep={setActiveStep}
        activeStep={activeStep}
        step={ORDER_APIS_STEPPER_FOOTER.CONFIGURE_CMF}
        isContinueDisabled={
          !isAllBundlesCMFConfigured
        }
        cart={cart}
      />
    </>
  );
}